<template>
  <div>

    <div>
      <b-tabs justified
              active-nav-item-class="font-weight-bold text-success"
              active-tab-class="font-weight-bold"
              content-class="mt-3">
        <!--------first tab------->
        <b-tab title="مراحل الگو" active>
          <div>
            <div>
              <div class="row mt-2">
                <div class="col-4 mt-2">
                  <div class="input-group">
                    <div class="input-group-prepend custom">
                      <div class="input-group-text">
                        <span>کارگاه(تولید کننده)</span>
                      </div>
                    </div>
                    <!--<input v-model="server.name" type="text" class="form-control">-->
                    <vs-select
                      ref="preCompanies"
                      :data="stateItems"
                      :header="{label: 'companyName'}"
                      :mode="'edit'"
                      :is-header="true"
                      :selected-val="workshopSelectedVal"
                      @onChange="onPreCompanyChange"
                    ></vs-select>
                  </div>
                </div>
                <h2 style="padding-top: 0.6rem">=></h2>
                <div class="col-4 mt-2">
                  <div class="input-group">
                    <div class="input-group-prepend custom">
                      <div class="input-group-text">
                        <span>کارگاه(مقصد)</span>
                      </div>
                    </div>
                    <!--<input v-model="server.name" type="text" class="form-control">-->
                    <vs-select
                      ref="companies"
                      :data="stateItems"
                      :header="{label: 'companyName'}"
                      :mode="'edit'"
                      :is-header="true"
                      :selected-val="workshopSelectedVal"
                      @onChange="onWorkshopsChange"
                    ></vs-select>
                  </div>
                </div>

                <div class="col-3 text-center mt-2">
                  <button class="btn iconed btn-secondary" id="btn-addProduct" @click="createReceiveProducts">
                    <i
                      class="icon-dropbox"></i><span>افزودن کالای تولیدی</span></button>
                </div>
                <!-- <div class="col-2 text-center mt-2">
                   <button class="btn iconed btn-secondary" id="btn-addToTable" @click="addRowsToTable"><i
                     class="icon-bd-plus"></i><span>افزودن به جدول</span></button>
                 </div>-->
              </div>
              <div class="row mt-4">
                <div class="col-3 input-group">
                  <div class="input-group-prepend custom">
                    <div class="input-group-text">
                      <span>زمان استاندارد</span>
                    </div>
                  </div>
                  <input v-model="newRow.standardTime" type="text" class="form-control" placeholder="ورود زمان الزامی است">
                </div>
                <!--<div class="col-3 input-group">-->
                  <!--<div class="input-group-prepend custom">-->
                    <!--<div class="input-group-text">-->
                      <!--<span>زمان دستگاه</span>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<input v-model="newRow.deviceTime" type="text" class="form-control">-->
                <!--</div>-->
                <!--<div class="col-3 input-group">-->
                  <!--<div class="input-group-prepend custom">-->
                    <!--<div class="input-group-text">-->
                      <!--<span>زمان نفرات</span>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<input v-model="newRow.personTime" type="text" class="form-control">-->
                <!--</div>-->
                <!--<div class="col-3 input-group">-->
                  <!--<div class="input-group-prepend custom">-->
                    <!--<div class="input-group-text">-->
                      <!--<span>زمان انتقال</span>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<input v-model="newRow.transmitionTime" type="text" class="form-control">-->
                <!--</div>-->
              </div>
              <div class="row mt-4">
                <div class="col-lg-12 justify-content-center text-center" id="btn-addToTable">
                  <button type="button" class="btn btn-success btn-addToTable w-25" @click="addRowsToTable"
                          :disabled="!this.newRow.preCompany.id || !this.newRow.company.id || !this.newRow.standardTime">افزودن به جدول
                  </button>
                </div>
              </div>
              <table class="table mt-3">
                <thead>
                <tr>
                  <th scope="col" class="text-center">ردیف</th>
                  <th scope="col" class="text-center">کارگاه پیش نیاز</th>
                  <th scope="col" class="text-center">کارگاه</th>
                  <th scope="col" class="text-center">مجموع ساعات</th>
                  <th scope="col" class="text-center">عملیات</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) of preconditions">
                  <th scope="row" class="text-center">{{index + 1}}</th>
                  <td class="text-center">{{item.preCompany.name}}</td>
                  <td class="text-center">{{item.company.name}}</td>
                  <td class="text-center">{{item.preCompany.standardTime}}</td>
                  <td class="text-center">
                    <button class="btn btn-secondary ml-2" @click="showReceiveProducts(item)"
                            data-toggle="tooltip" title="نمایش کالاها"><i class="icon-dropbox"></i>
                    </button>
                    <button class="btn btn-secondary"
                            @click="removePrecondition(item)"><i
                      class="icon-bd-delete"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <!--Add Products Modal-->
            <b-modal
              ref="pattern-decoration"
              id="receive-products-create"
              size="lg"
              title="کالاهای دریافتی"
              ok-title="بستن"
              @ok="resetProductForm"
              ok-only
            >
              <div class="row mt-4">
                <div class="col-6 mt-2">
                  <div class="input-group">
                    <div class="input-group-prepend custom">
                      <div class="input-group-text">
                        <span>کالای دریافتی</span>
                      </div>
                    </div>
                    <!--<input v-model="server.name" type="text" class="form-control">-->
                    <vs-select
                      ref="receiveProducts"
                      :data="receiveProducts"
                      :header="{label: 'productName'}"
                      :mode="'edit'"
                      :is-header="true"
                      :selected-val="receivedProductSelectedVal"
                      @onChange="onReceivedProductChange"
                    ></vs-select>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <div class="input-group">
                    <div class="input-group-prepend custom">
                      <div class="input-group-text">
                        <span>تعداد</span>
                      </div>
                    </div>
                    <input v-model="inputReceiveProduct.count" placeholder="تعداد محصول" type="number"
                           class="form-control">
                    <p class="mt-1 mb-0 appending-text">(اگر کالا تولیدی است: تعداد تولید کالای ناخالص در ساعت را وارد کنید)</p>
                    <p class="mt-1 mb-0 appending-text">(اگر کالا ضایعاتی است: مقدار ضایعات در هر عدد تولید را وارد کنید)</p>

                  </div>
                </div>
                <div class="col-12 text-center mt-3">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="defaultUnchecked"
                           v-model="inputReceiveProduct.storeDiscount">
                    <label class="custom-control-label text-bold" for="defaultUnchecked">آیا کالا ضایعاتی است؟</label>
                    <p class="mt-1 mb-0 appending-text">(کالای ضایعاتی در اثر تولید بوجود میآید و از انبار کسر نمیشود)</p>
                  </div>
                </div>
                <!--<div class="col-12 text-center mt-3 ">-->
                <!--<div class="custom-control custom-checkbox">-->
                <!--<input type="checkbox" class="custom-control-input">-->
                <!--<label>-->
                <!--<span class="switch-label text-bold">کالا بدون کسر از انبار؟ </span>-->
                <!--</label>-->
                <!--</div>-->
                <!--</div>-->
                <div class="col-12 text-center mt-3">
                  <button class="btn iconed btn-secondary" id="btn-add" @click="addToReceivedProductsTable"><i
                    class="icon-bd-plus"></i><span>افزودن به کالاها</span></button>
                </div>


                <table class="table mt-3">
                  <thead>
                  <tr>

                    <th scope="col" class="text-center">عملیات</th>
                    <th scope="col" class="text-center">ردیف</th>
                    <th scope="col" class="text-center">نام کالا</th>
                    <th scope="col" class="text-center">کالای ضایعاتی</th>
                    <th scope="col" class="text-center">تعداد</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) of newRow.receivedProducts">

                    <td class="text-center">
                      <button :id="'btn-delete-'" class="btn btn-secondary" @click="deleteReceiveProduct(item)">
                        <i
                          class="icon-bd-delete"></i></button>
                    </td>
                    <th scope="row" class="text-center">{{index + 1}}</th>
                    <td class="text-center">{{item.name}}</td>
                    <td class="text-center" v-if="item.storeDiscount"><i class="fa fa-check"></i></td>
                    <td class="text-center" v-else><i class="fa fa-minus"></i></td>
                    <td class="text-center">{{item.count}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-modal>
            <!--show Products Modal View Mode-->
            <b-modal
              ref="receiveProductsViewMode"
              id="receive-products-view"
              size="md"
              title="کالاهای دریافتی"
              ok-title="بستن"
              @ok="closeReceiveProductsModal"
              ok-only
            >
              <div class="row mt-4">
                <table class="table mt-3">
                  <thead>
                  <tr>
                    <th scope="col" class="text-center">عملیات</th>
                    <th scope="col" class="text-center">ردیف</th>
                    <th scope="col" class="text-center">نام کالا</th>
                    <th scope="col" class="text-center">کالای ضایعاتی</th>
                    <th scope="col" class="text-center">تعداد</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) of receiveProductsViewMode">

                    <td class="text-center">
                      <button :id="'btn-delete-'" class="btn btn-secondary" @click="deleteReceiveProduct(item)">
                        <i
                          class="icon-bd-delete"></i></button>
                    </td>
                    <th scope="row" class="text-center">{{index + 1}}</th>
                    <td class="text-center">{{item.name}}</td>
                    <td class="text-center" v-if="item.storeDiscount"><i class="fa fa-check"></i></td>
                    <td class="text-center" v-else><i class="fa fa-minus"></i></td>
                    <td class="text-center">{{item.count}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-modal>
          </div>
        </b-tab>
        <!--------second tab------->

        <b-tab title="سوالات">
          <div class="row mt-2  ">
            <div class="col-5 mt-2 ">
              <div class="input-group">
                <div class="input-group-prepend custom">
                  <div class="input-group-text">
                    <span>کارگاه</span>
                  </div>
                </div>
                <!--<input v-model="server.name" type="text" class="form-control">-->
                <vs-select
                  ref="Companies"
                  :data="stateItems"
                  :header="{label: 'companyName'}"
                  :mode="'edit'"
                  :is-header="true"
                  :selected-val="workshopSelectedVal"
                  @onChange="onQuestionsStateChange"
                ></vs-select>
              </div>
            </div>
          </div>
          <hr class="hr-text">
          <div class="row text-center mt-2">
            <div class="col-12">
              <button class="btn iconed btn-warning" id="btn-addQuestion" @click="addQuestion"
                      :disabled="addQuestionStatus === false" style="border-radius: 2rem">
                <span>افزودن سوال</span>
              </button>
            </div>

          </div>


          <div class="view-mode" v-if="questionTableMode === 'view'">
            <table class="table table-borderless" v-if="showQuestionsTable">
              <thead>
              <tr>
                <th class="text-center" scope="col">شماره سوال</th>
                <th class="text-center" scope="col">سوال</th>
                <th class="text-center" scope="col">نوع پاسخ</th>
                <th class="text-center" scope="col">پاسخ استاندارد</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item of allQuestions">
                <td class="text-center" scope="row">{{item.index}}</td>
                <td class="text-center">{{item.question}}</td>
                <td class="text-center">{{item.answerType.title}}</td>
                <td class="text-center">{{checkNullable(item.standardAnswer)}}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="edit-mode" v-else>
            <table class="table table-borderless">
              <thead>
              <tr>
                <th class="text-center" scope="col">شماره سوال</th>
                <th class="text-center" scope="col">سوال</th>
                <th class="text-center" scope="col">نوع پاسخ</th>
                <th class="text-center" scope="col">پاسخ استاندارد</th>
                <th class="text-center" scope="col">عملیات</th>
              </tr>
              <tr>
                <th class="text-center" scope="col">
                  <input class="form-control" v-model="questionModel.index">
                </th>
                <th class="text-center" scope="col">
                  <input class="form-control" v-model="questionModel.question">
                </th>
                <th class="text-center" scope="col">

                  <vs-select
                    ref="questionsType"
                    :data="questionsTypes"
                    :header="{label: 'title'}"
                    :mode="'edit'"
                    :is-header="true"
                    :selected-val="questionTypeSelectedVal"
                    @onChange="onQuestionTypeChange"
                  ></vs-select>
                </th>
                <th class="text-center" scope="col">
                  <input class="form-control" v-model="questionModel.standardAnswer">
                </th>
                <th class="text-center" scope="col">
                  <button class="btn iconed btn-success" id="acceptQuestion" @click="acceptQuestion">
                    <span class="text-center">ثبت</span>
                  </button>
                  <button class="btn iconed btn-danger mx-2" id="ignoreQuestion" @click="ignoreQuestion">
                    <span class="text-center">لغو</span>
                  </button>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in allQuestions">
                <td class="text-center" scope="row">{{item.index}}</td>
                <td class="text-center">{{item.question}}</td>
                <td class="text-center">{{convertDigitToText(item.answerType.value)}}</td>
                <td class="text-center">{{checkNullable(item.standardAnswer)}}</td>
                <td class="text-center"></td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-tab>

        <!--------third tab------->
        <b-tab title="پیش نمایش" @click="showPreviewPattern(true)">

          <div>
            <vue-mermaid class='mermaid align-items-center d-flex justify-content-center' :nodes="flowchartData"
                         type="graph LR" @nodeClick="editNode"></vue-mermaid>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>

</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import EventBus from "../bus.js";
  import Products from "../pages/Products";
  import Moment from "moment-jalali";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import VsSelect from "../_framework/VsSelect";
  import BaseService from "../_framework/api/BaseService.js";
  import BdSelectCompanyModal from "../components/BDSelectCompanyModal.vue";
  import BdProductOrderModal from "../components/BDProductOrderModal.vue";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Utils from "../_framework/utils/Utils.js";
  import * as $ from 'jquery';

  export default {
    name: "order-form",
    props: {
      pattern: Object,
      preconditions: Array,
      stateItems: Array,
      stateQuestions: Array
    },
    components: {
      VsTable,
      Moment,
      datePicker: DatePicker,
      VsSelect,
      BdSelectCompanyModal,
      BdProductOrderModal
    },
    data() {
      return {
        flowchartData: [],
        previewPattern: false,
        deletePattern: {},
        explainPattern: {},
        workshops: [],
        workshopSelectedVal: null,
        preCompanies: [],
        preCompanySelectedVal: null,
        receiveProducts: [],
        receivedProductSelectedVal: null,
        workshopName: null,
        preCompanyName: null,
        workshopId: 0,
        preCompanyId: 0,
        productsTableRow: [],
        newRow: {
          company: {
            id: undefined,
            name: undefined
          },
          preCompany: {
            id: undefined,
            name: undefined,
          },
          standardTime: 1,
          deviceTime: 0,
          personTime: 0,
          transmitionTime: 0,
          receivedProducts: []
        },
        receiveProductsViewMode: [],
        inputReceiveProduct: {
          id: undefined,
          name: undefined,
          count: undefined,
          storeDiscount: false
        },
        allQuestions: [],
        // questionsOnViewMode: [],
        showQuestionsTable: false,
        questionTableMode: "view",
        addQuestionStatus: false,
        questionModel: {
          index: null,
          question: "",
          answerType: {
            title: '',
            value: 0
          },
          standardAnswer: null,
        },
        newQuestionModel: {
          index: null,
          question: "",
          answerType: {
            title: '',
            value: 0
          },
          standardAnswer: null,
        },
        questionsRow: [],
        questionsTypes: [],
        stateId: 0,
        /*  receiveStateQuestions: {
              id: null,
              name: null
          },*/
        questionTypeSelectedVal: null,
      };
    },
    mounted() {
      // this.getRelatedCompanies(this.pattern.id);
      /*  this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
          $(`#btn-delete-${this.deletePattern.id}`).removeClass("btn-danger");
          this.deletePattern = {}
        });*/

      this.resetProductForm();

    },
    methods: {
      convertDigitToText(val) {
        if (val === 0) {
          return "متن"
        } else if (val === 1) {
          return "عدد"
        } else if (val === 2) {
          return "صحیح، غلط"
        } else if (val === 3) {
          return "زمان"
        } else {
          return "-"
        }
      },
      setQuestionTypes() {
        new BaseService('Patterns', '/GetConfirmFormAnswerTypes').getList().then((response) => {
          this.questionsTypes = response.data;
        }).catch((error) => {
          console.log(error)
        })
      },
      onQuestionTypeChange(val) {
        // console.log(val)
        if (val) {
          this.questionModel.answerType.value = val.value;
          this.questionModel.answerType.title = val.title;
        }
      },
      onQuestionsStateChange(val) {
        this.stateId = val.id;
        // this.questionsArray = this.stateQuestions;
        if (val) {
          // this.recieveStateQuestions = val;
          const state = this.stateQuestions.find(a => a.id === val.id);
          if (state.questions.length > 0) {
            this.allQuestions = state ? state.questions : [];
            // this.questionsOnViewMode = state ? state.questions : [];
          }
          // this.allQuestions = this.stateQuestions.questions;
          this.showQuestionsTable = true;
          this.addQuestionStatus = true
        } else {
          this.showQuestionsTable = false;
          this.addQuestionStatus = false
        }
        // console.log(this.questionsOnViewMode)
      },
      addQuestion() {
        this.questionTableMode = "create";
        this.setQuestionTypes();
      },
      createQuestion() {
        this.newQuestionModel.index = parseInt(this.questionModel.index);
        this.newQuestionModel.question = this.questionModel.question;
        this.newQuestionModel.answerType.value = this.questionModel.answerType.value;
        this.newQuestionModel.standardAnswer = this.questionModel.standardAnswer;
        let model = {
          stateId: this.stateId,
          // questions: this.allQuestions
          questions: [this.newQuestionModel]
        };
        console.log(model)

        if (!this.stateQuestions) {
          this.$noty.error("انتخاب کارگاه الزامیست")
        } else {
          this.$emit('add-new-question', model);
          // console.log(this.receiveProductsViewMode);
          // this.resetValues();
        }
      },
      acceptQuestion() {
        // console.log(this.allQuestions)
        // console.log(this.stateQuestions.id)
        let model = JSON.parse(JSON.stringify(this.questionModel));
        this.allQuestions.push(model);
        this.$refs.questionsType.$data.selectedValue = null;
        this.createQuestion();
        this.questionTableMode = "view";
        setTimeout(() => {
          Utils.resetObject(this.questionModel);
        }, 1000);
        // this.allQuestions.push(this.questionModel);
      },
      ignoreQuestion() {
        this.questionTableMode = "view";
        // this.removeRow(index)
      },
      /*addRow() {
          this.allQuestions.push(this.questionModel);
      },
      removeRow(index) {
          if (this.allQuestions.length > 1) {
              this.allQuestions.splice(index, 1)
          }
      },*/
      showPreviewPattern(bool) {
        this.previewPattern = bool;
        if (this.previewPattern) {
          this.flowchartData = this.previewFlowchart();
        }
      },
      previewFlowchart() {
        const data = [];
        for (let s of this.stateItems) {
          data.push({
            id: `${s.id}`,
            text: s.companyName,
            edgeType: 'default',
            style: '',
            next: this.preconditions.filter(p => p.preCompany.id === s.id).map(c => `${c.company.id}`)
          });
        }

        return data;
      },
      editNode(nodeId) {
        // alert(nodeId);
      },
      closeReceiveProductsModal() {

      },
      createReceiveProducts() {
        this.$root.$emit('bv::show::modal', 'receive-products-create')
      },
      showReceiveProducts(item) {
        this.receiveProductsViewMode = item.receivedProducts.map(a => ({
          id: a.id,
          name: a.name,
          count: a.count,
          storeDiscount: a.storeDiscount
        }));
        this.$root.$emit('bv::show::modal', 'receive-products-view')
      },
      resetProductForm() {
        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
          $(`#btn-explain-${this.explainPattern.id}`).removeClass("btn-warning");
          this.resetProductModal();
        });
      },
      resetValues() {
        this.newRow.company.id = undefined;
        this.newRow.company.name = undefined;
        this.newRow.preCompany.id = undefined;
        this.newRow.preCompany.name = undefined;
        this.newRow.standardTime = 1;
        this.newRow.deviceTime = null;
        this.newRow.personTime = null;
        this.newRow.transmitionTime = null;
        this.newRow.receivedProducts = [];
        if (this.$refs.companies) {
          this.$refs.companies.$data.selectedValue = null;
        }
        if (this.$refs.preCompanies) {
          this.$refs.preCompanies.$data.selectedValue = null;
        }
        if (this.$refs.receiveProducts) {
          this.$refs.receiveProducts.$data.selectedValue = null;
        }
        this.resetProductModal();
      },
      resetProductModal() {
        this.inputReceiveProduct.id = undefined;
        this.inputReceiveProduct.name = undefined;
        this.inputReceiveProduct.count = undefined;
        this.inputReceiveProduct.storeDiscount = false;
        if (this.$refs.receiveProducts) {
          this.$refs.receiveProducts.$data.selectedValue = null;
        }
      },
      onWorkshopsChange(val) {

        if (!val) {
          this.newRow.company.id = undefined;
          this.newRow.company.name = undefined;
        } else {
          this.newRow.company.id = val.id;
          this.newRow.company.name = val.companyName;
        }
      },
      onPreCompanyChange(val) {

        if (!val) {
          this.newRow.preCompany.id = undefined;
          this.newRow.preCompany.name = undefined;
        } else {
          this.newRow.preCompany.id = val.id;
          this.newRow.preCompany.name = val.companyName;

          this.getReceivedProducts();
        }
      },
      onReceivedProductChange(val) {
        if (!val) {
          this.inputReceiveProduct.id = undefined;
          this.inputReceiveProduct.name = undefined;
        } else {
          this.inputReceiveProduct.id = val.id;
          this.inputReceiveProduct.name = val.productName;
        }
      },

      addToReceivedProductsTable() {
        if (!this.inputReceiveProduct || !this.inputReceiveProduct.count || !this.inputReceiveProduct.id || !this.inputReceiveProduct.name) {
          this.$noty.error("انتخاب محصول و تعداد الزامیست");
        } else {
          this.newRow.receivedProducts.push({
            id: this.inputReceiveProduct.id,
            name: this.inputReceiveProduct.name,
            count: this.inputReceiveProduct.count,
            storeDiscount: this.inputReceiveProduct.storeDiscount
          });
          console.log(this.receiveProductsViewMode);
          this.resetProductModal();
        }
      },
      addRowsToTable() {
        if (!this.newRow.company.id || !this.newRow.company.name) {
          this.$noty.error("انتخاب کارکاه و کارگاه پیش نیاز الزامیست")

        } else if(!this.newRow.standardTime){
          this.$noty.error("وارد کردن زمان استاندارد الزامیست")
        }else {
          this.$emit('add-new-precondition', {
            company: {
              id: this.newRow.company.id,
              name: this.newRow.company.name
            },
            preCompany: {
              id: this.newRow.preCompany.id,
              name: this.newRow.preCompany.name
            },
            standardTime: this.newRow.standardTime,
            deviceTime: this.newRow.deviceTime,
            personTime: this.newRow.personTime,
            transmitionTime: this.newRow.transmitionTime,
            receivedProducts: this.newRow.receivedProducts.map(a => ({
              id: a.id,
              name: a.name,
              count: a.count,
              storeDiscount: a.storeDiscount
            }))
          });
          // console.log(this.receiveProductsViewMode);
          this.resetValues();
        }

      },
      removePrecondition(pre) {
        this.$emit('remove-precondition', pre);
      },
      deleteReceiveProduct(item) {
        this.newRow.receivedProducts = this.newRow.receivedProducts.filter(a => a !== item);
      },
      getReceivedProducts() {
        new BaseService('Products', `/GetDropDownModel`).getList().then((response) => {
          // console.log(response.data)
          this.receiveProducts = response.data.map(a => ({
            id: a.id,
            productName: a.productName
          }))
        }).catch((error) => {
          console.log(error)
        })
      },
      hideModal() {
        this.$refs.pattern.hide();
        this.$refs.deleteModal.hide();
        this.resetForm();
        $(`#btn-delete-${this.deletePattern.id}`).removeClass("btn-danger");
        setTimeout(() => {
          this.getAllPatterns();
          this.deletePattern.id = {}
        }, 1000)
      },
      createPatternDecoration(item, index) {
        // console.log(item)
        this.explainPattern = item;
        $(`#btn-explain-${item.id}`).addClass("btn-warning")

      },
      checkNullable(val) {
        if (val) {
          return val
        } else {
          return "-"
        }

      }
    },

    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"]),
      mode() {
        return this.$route.query._mode;
      }
    },
    watch: {
      vsTableFeed(val) {
        this.refreshOrderProductsTable();
      }
    }
  };
</script>

<style scoped>
  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }

  .v-select .dropdown-toggle input {
    width: 100% !important;
  }

  .hover-pointer:hover {
    cursor: pointer;
  }

  .btn-preview {
    background-color: #4dbd74 !important;
    border-radius: 2rem
  }

  .btn-preview:hover {
    box-shadow: 0px 0px 10px 2px rgba(60, 140, 84, 0.5);
  }

  .btn-addToTable {
    border-radius: 2rem;
    background-color: #4dbd74 !important;
  }

  hr {
    margin: 30px auto 0;
    width: 90%;
    border: 0;
    height: 1.2px;
    background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(198, 198, 198, 0.75), rgba(255, 255, 255, 0));
  }

  .appending-text {
    color: #9c9c9c;
    font-size: 12px;
  }
</style>
